import { useState, useEffect } from 'react';

const useVideoLength = (videoUrl) => {
  const [videoLength, setVideoLength] = useState<number | null>(null);

  useEffect(() => {
    const video = document.createElement('video');
    video.src = videoUrl;

    const handleMetadataLoaded = () => {
      setVideoLength(Math.round(video.duration / 60));
      video.removeEventListener('loadedmetadata', handleMetadataLoaded);
    };

    video.addEventListener('loadedmetadata', handleMetadataLoaded);
    video.load();

    return () => {
      video.removeEventListener('loadedmetadata', handleMetadataLoaded);
    };
  }, [videoUrl]);

  return videoLength;
};

export default useVideoLength;
